import React, { useEffect, useState, useContext, useCallback, useRef } from 'react';
import { withNamespaces } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchFnbItems,
  onSelectFnb,
  onUpdateSelectedCombo,
  clearFnbState,
  saveFnbItems,
  fetchFnbCategories,
} from '@store/foodAndBeverages/foodAndBeveragesActions';
import {
  Container,
  Dropdown,
  Modal,
  Button,
  Alert,
  Accordion,
  Card,
} from 'react-bootstrap';
import useIsTablet from '@src/customHooks/useIsTablet';
import dummyPosterStatic from '@assets/pictures/dummyPoster.png';
import { toast } from 'react-toastify';
import {
  fnbItemsWithSearchSelector,
  fnbItemCategoriesSelector,
} from '@store/foodAndBeverages/foodAndBeveragesSelectors';
import FnbService from '@apiService/FnbService.js';
import popcorn from '@assets/pictures/popcorn.png';
import fnbSample from '@assets/pictures/fnb-sample.jpg';
import { useParams } from 'react-router';
import Spinner from './partials/Spinner';
import { ReactComponent as ArrowBack } from '@assets/pictures/svgs/arrow-back.svg';
import { ReactComponent as ArrowBackActive } from '@assets/pictures/svgs/arrow-back-active.svg';
import { ReactComponent as DropDownArrow } from '@assets/pictures/svgs/dropdown-arrow.svg';
import { ReactComponent as NewDropDownArrow } from '@assets/pictures/svgs/newdroparrow.svg';
import { motion } from 'framer-motion';
import useIsMobile from '../customHooks/useIsMobile';
import searchIcon from '@assets/pictures/svgs/search-fnb-new.svg';
import close from '@assets/pictures/svgs/close.svg';
import { currencyFormatter } from '@helper/currencyFormatter';
import { getLangSpecificAttribute } from '@helper/languages';
/*import 'antd/dist/antd.css';*/
import { Row, Col } from 'antd';
/*import { ArrowLeftOutlined } from "@ant-design/icons";*/
import _ from 'lodash';
import { seatTypesSelector } from '@store/movies/movieSelector';
import {
  fetchReservationDetails,
  fetchReservationDetailsBrij,
  fetchStripePublisherKey,
  fetchActivePaymentModes,
} from '@store/movies/movieActions';
import { setReservationID } from '@store/seatLayout/seatLayoutActions';
import '../assets/css/style.css';
import { ReactComponent as LeftArrow } from '@assets/pictures/svgs/slider-arrow-left.svg';
import GoBack from '@components/partials/GoBack';

import { ReactComponent as FnbAdd } from '@assets/pictures/svgs/fnb-add.svg';
import { ReactComponent as FnbAddGold } from '@assets/pictures/svgs/fnb-add-gold.svg';
import { ReactComponent as FnbRemove } from '@assets/pictures/svgs/fnb-remove.svg';
import moment from 'moment';

const Fnb = ({ t }) => {
  const {
    ss_id,
    screen_id,
    md_id,
    mycinema_ss_d_id,
    booking_type_id,
    fnb_item_id,
  } = useParams();
  let category_id = ss_id && screen_id && md_id ? 2 : 1;
  const [back, setBack] = useState(false);
  const [itemType, setItemType] = useState('all');
  const isMobile = useIsMobile();
  const [footerAccordion, setFooterAccordion] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [compulsoryItem, setCompulsoryItem] = useState([]);
  const [compulsoryItemAdded, setCompulsoryItemAdded] = useState(false);
  const [pressedProceed, setpressedProceed] = useState(false);
  const [showElement, setShowElement] = useState(false);
  const [showComboEditPopup, setShowComboEditPopup] = useState(false);
  const [tempSelectedFnb, setTempSelectedFnb] = useState(null);
  const [tempSelectedFnbItemIndex, setSelectedFnbItemIndex] = useState(null);

  const history = useHistory();
  const isTablet = useIsTablet();
  const dispatch = useDispatch();
  const reservation_id = useSelector((state) => state.seatLayout.reservation_id);
  // const fnbItems = useSelector((state) => state.fnb.fnb_items);
  const fnbItemsLoader = useSelector((state) => state.fnb.fnb_loader);

  const currency = useSelector((state) => state.movies.currency);
  const { curr_code, curr_id } = currency;

  // const fnbCategories = useSelector((state) =>
  //   fnbItemCategoriesSelector(state)
  // );
  const fnbCategories = useSelector((state) => state.fnb.fnb_categories);
  const fnbItemsWithSearch = useSelector((state) =>
    fnbItemsWithSearchSelector(state, search, selectedCategory),
  );
  let sortedFnbItemArr = _.sortBy(fnbItemsWithSearch, ['fc_order', 'fi_order']);

  const currentDate = moment().startOf('day');

  const visibleFnbItems = sortedFnbItemArr.filter((item) => {
    const fromDate = item?.fp_from_date
      ? moment(item.fp_from_date).startOf('day')
      : null;

    const toDate = item?.fp_to_date ? moment(item.fp_to_date).startOf('day') : null;

    // 1. Both null → show
    if (!fromDate && !toDate) {
      return true;
    }

    // 2. From date set, To date null → current >= from
    if (fromDate && !toDate) {
      return currentDate.isSame(fromDate, 'day') || currentDate.isAfter(fromDate);
    }

    // 3. From date null, To date set → current <= to
    if (!fromDate && toDate) {
      return currentDate.isSame(toDate, 'day') || currentDate.isBefore(toDate);
    }

    // 4. Both set → from <= current <= to
    return (
      (currentDate.isSame(fromDate, 'day') || currentDate.isAfter(fromDate)) &&
      (currentDate.isSame(toDate, 'day') || currentDate.isBefore(toDate))
    );
  });

  // console.log(sortedFnbItemArr, 'sortedArr');
  // .sort((a, b) => parseFloat(a.fi_order) - parseFloat(b.fi_order));
  // console.log('fnbItemsWithSearch', fnbItemsWithSearch);
  const selectedFnbItems = useSelector((state) => state.fnb.selected_fnb_items);
  const all_fnb_items = useSelector((state) => state?.fnb?.fnb_items);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowElement(true);
    }, 8000);

    return () => clearTimeout(timer);
  }, []);

  let newfnbCategories = all_fnb_items.map((x) => ({
    ['fc_id']: x?.fc_id,
    ['fc_order']: x?.fc_order,
    ['fc_category']: x?.fc_category,
    ['FnbCategoryContent']: [...x?.FnbCategoryContent],
  }));

  let jsonObject = newfnbCategories.map(JSON.stringify);
  let uniqueSet = new Set(jsonObject);
  let fnbCategoriesuniqueArray = Array.from(uniqueSet).map(JSON.parse);

  // console.log(fnbCategoriesuniqueArray, 'fnbCategoriesuniqueArray');
  const fnbPrice = useSelector((state) => state.fnb.fnb_price);

  const scheduleDetails = useSelector((state) => state.movies.scheduleDetails);

  // console.log(scheduleDetails, 'scheduleDetails');
  const selected_language = useSelector((state) => state.movies.selected_language);

  const { lang_name, iso_2, lang_id } = selected_language;

  useEffect(() => {
    if (scheduleDetails) {
      dispatch(
        fetchFnbItems({ cinema_id: scheduleDetails.cinema_id, reservation_id }),
      );
      dispatch(fetchFnbCategories());
    }
  }, [scheduleDetails]);

  function footerAccordionHandler() {
    if (window.innerWidth < 768) {
      setFooterAccordion(true);
    } else if (window.innerWidth >= 768) {
      setFooterAccordion(false);
    }
  }

  window.addEventListener('resize', footerAccordionHandler);
  useEffect(footerAccordionHandler, []);

  const goToSeatLayout = useCallback(() => {
    if (mycinema_ss_d_id && booking_type_id) {
      history.go(-1);

      // history.replace(
      //   `/create-show-seat-layout/${mycinema_ss_d_id}/${booking_type_id}`
      // );
    } else if (ss_id && screen_id && md_id) {
      history.go(-1);

      // history.replace(`/seat-layout/${ss_id}/${screen_id}/${md_id}`);
    }
  }, [mycinema_ss_d_id, booking_type_id, ss_id, screen_id, md_id]);

  const onEditCombo = (selectedItem, itemIndex) => {
    console.log('onClick Combo edit btn', selectedItem);
    setTempSelectedFnb(selectedItem);
    setSelectedFnbItemIndex(itemIndex);
    setShowComboEditPopup(true);
  };

  const getComboQtyText = (categoryIndex) => {
    const tempItemCount =
      (tempSelectedFnb?.quantity
        ? tempSelectedFnb?.quantity
        : tempSelectedFnb?.Quantity) || 0;
    let selectedCategory = {
      min_max_setting: 'N',
      min_quantity: 0,
      max_quantity: 0,
      quantity: 0,
    };
    Object.keys(selectedCategory).map((key) => {
      selectedCategory[key] =
        tempSelectedFnb?.combo_pack[categoryIndex][key] || selectedCategory[key];
    });
    let newQty = selectedCategory['quantity'] * tempItemCount;
    let newMinQty = selectedCategory['min_quantity'] * tempItemCount;
    let newMaxQty = selectedCategory['max_quantity'] * tempItemCount;
    let text = ``;
    if (selectedCategory['min_max_setting'] == 'Y') {
      text = `Min Qty. ${newMinQty} & Max Qty. ${newMaxQty}`;
    } else {
      text = `Select Atleast ${newQty} Quantity`;
    }
    return text;
  };

  const onChangeComboItems = (food, index, category, categoryindex, type) => {
    const tempItemCount =
      (tempSelectedFnb?.quantity
        ? tempSelectedFnb?.quantity
        : tempSelectedFnb?.Quantity) || 0;
    let totalItemSelected = tempSelectedFnb?.combo_pack[
      categoryindex
    ]?.combo_items?.reduce((acc, { quantity }) => acc + parseInt(quantity || 0), 0);
    if (type == 'add') {
      if (category['min_max_setting'] == 'Y') {
        if (totalItemSelected >= category.max_quantity * tempItemCount) {
          toast.error('All items Selected for this category');
        } else {
          tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity++;
        }
      } else {
        if (totalItemSelected >= category.quantity * tempItemCount) {
          toast.error('All items Selected for this category');
        } else {
          tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity++;
        }
      }
    } else if (type == 'minus') {
      if (
        tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity > 0
      ) {
        tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity--;
      }
    }
  };

  const onSaveComboChanges = () => {
    let errorCount = 0;
    let errMsg = '';
    let finalComboPack = [];
    const tempItemCount =
      (tempSelectedFnb?.quantity
        ? tempSelectedFnb?.quantity
        : tempSelectedFnb?.Quantity) || 0;
    tempSelectedFnb.combo_pack.forEach((category, categoryIndex) => {
      let checkQuantity = 0;
      let categoryQty =
        category['min_max_setting'] == 'Y'
          ? category.min_quantity * tempItemCount
          : category.quantity * tempItemCount;
      category.combo_items.forEach((items) => {
        checkQuantity += items.quantity;
        if (items.quantity > 0) {
          finalComboPack.push(items);
        }
      });
      if (checkQuantity < categoryQty) {
        errorCount++;
        errMsg = `Please Select ${parseInt(
          categoryQty - checkQuantity,
        )} more Item for ${category.category_name} category`;
      }
    });

    if (errorCount > 0) {
      toast.error(errMsg);
      return false;
    } else {
      dispatch(
        onUpdateSelectedCombo({
          itemIndex: tempSelectedFnbItemIndex,
          final_combo_array: _.cloneDeep(finalComboPack),
        }),
      );
      setShowComboEditPopup(false);
    }
  };
  const proceedToPayment = (skip = false) => {
    if (!pressedProceed) {
      setpressedProceed(true);

      if (skip && !compulsoryItemAdded) {
        dispatch({ type: 'CLEAR_FNB_STATE' });
        history.push(`/payment/${reservation_id}/${category_id}`);
        return;
      }

      // perform reservation here
      if (selectedFnbItems?.length === 0) {
        // history.push(`/payment/${reservation_id}/${category_id}`);
        dispatch(saveFnbItems(category_id)).then((status) => {
          if (status) {
            history.push(`/payment/${reservation_id}/${category_id}`);
          } else {
            setpressedProceed(false);
          }
        });
      } else {
        dispatch(saveFnbItems(category_id)).then((status) => {
          if (status) {
            history.push(`/payment/${reservation_id}/${category_id}`);
          } else {
            setpressedProceed(false);
          }
        });
      }
    }
  };

  if (!reservation_id) {
    goToSeatLayout();
  }

  function percentage(percent, total) {
    return (percent / 100) * total;
  }

  useEffect(() => {
    category_id == 1
      ? dispatch(fetchReservationDetails({ reservation_id, category_id }))
      : dispatch(fetchReservationDetailsBrij({ reservation_id, category_id }));
    window.scrollTo(0, 0);
    dispatch(fetchStripePublisherKey());
    dispatch(fetchActivePaymentModes(2));
    dispatch(setReservationID(reservation_id));
  }, []);

  const booking_type = useSelector((state) => state.movies.booking_type);
  const reservationDetails = useSelector(
    (state) => state.movies.reservationDetails,
  );
  const reservationDetailsLoading = useSelector(
    (state) => state.movies.reservationDetailsLoading,
  );

  const add_ons_array = useSelector(
    (state) => state?.movies?.reservationDetails?.add_ons_array,
  );
  const is_internet_handling_enable = useSelector(
    (state) => state?.seatLayout?.is_internet_handling_enable,
  );
  const seatLayout = useSelector((state) => state?.seatLayout);

  const discount = useSelector((state) => state.promotions.voucher_discount);
  let private_rate_card_detail = reservationDetails?.private_rate_card_detail ?? [];

  let ticket_count =
    private_rate_card_detail.length > 0
      ? private_rate_card_detail[0].customSeatCount
      : null;

  const movieBottomRef = useRef();
  const movieInfoRef = useRef();
  useEffect(() => {
    const setMovieBottomWidth = () => {
      const movieBottom = movieBottomRef.current;
      const movieInfo = movieInfoRef.current;
      if (movieBottom && movieInfo) {
        movieBottom.style.width = movieInfo.offsetWidth + 'px';
      }
    };
    setMovieBottomWidth();
    window.addEventListener('resize', setMovieBottomWidth);
    return () => window.removeEventListener('resize', setMovieBottomWidth);
  }, []);

  const seatTypes = useSelector((state) => seatTypesSelector(state));

  useEffect(() => {
    // console.log({ scheduleDetails });
  }, [scheduleDetails]);
  useEffect(() => {
    // console.log({ reservationDetails });
    // console.log({ add_ons_array });
    // console.log({ is_internet_handling_enable, seatLayout });
  }, [reservationDetails, add_ons_array, is_internet_handling_enable, seatLayout]);

  //handling compulsory fnb Item
  useEffect(() => {
    if (compulsoryItem && compulsoryItem.length == 1 && !compulsoryItemAdded) {
      let seatCount = scheduleDetails?.selectedSeats?.length || 0;

      for (let i = 0; i < seatCount; i++) {
        dispatch(onSelectFnb('add', compulsoryItem[0]));

        setCompulsoryItemAdded(true);
      }
    }
  }, [compulsoryItem, scheduleDetails]);

  useEffect(() => {
    if (!!fnb_item_id) {
      let item = (all_fnb_items || []).filter(
        (item) => item?.item_id == fnb_item_id,
      );
      setCompulsoryItem(item);
    }
  }, [fnb_item_id, all_fnb_items, scheduleDetails]);

  function getRateCardAddonsTotal(add_ons_array = []) {
    if (!add_ons_array) return 0;
    if (add_ons_array?.length === 0) return 0;

    return add_ons_array?.[0]?.BoxOfficeFinal?.TotalAddons ?? 0;
  }
  function getInternetHandlingFees(
    category_id,
    is_internet_handling_enable,
    scheduleDetails,
    reservationDetails,
  ) {
    if (!is_internet_handling_enable) return 0;

    if (category_id == 2 && is_internet_handling_enable)
      return scheduleDetails?.internet_handling_fee ?? 0;
    else {
      if (reservationDetails?.selectedSeats?.length > 0)
        return (
          reservationDetails?.selectedSeats?.length *
          reservationDetails?.selectedSeats?.[0]?.internet_handling_fee
        );
      else return 0;
    }
  }

  if (reservationDetailsLoading)
    return (
      <div className="row d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );

  return (
    <>
      <style>
        {`.btn-main-new:hover{
          border-color:#1f1c3c !important;
          }`}
      </style>

      <Modal
        show={showComboEditPopup}
        className="alternate-fnb-popup"
        onHide={() => setShowComboEditPopup(false)}
        size="lg"
      >
        <Modal.Body>
          {tempSelectedFnb && tempSelectedFnb?.combo_pack?.length ? (
            <div className="combo_container">
              <div className="combo_title_bar">{tempSelectedFnb?.item_name}</div>
              <div className="combo_content">
                {tempSelectedFnb?.combo_pack?.map((category, catIndex) => {
                  return (
                    <div className="combo_content_wrapper" key={catIndex}>
                      <div className="d-flex align-items-center">
                        <div className="combo_category_name">
                          {category?.category_name}
                        </div>
                        <span class="combo-category-qty-count">
                          ({getComboQtyText(catIndex)})
                        </span>
                      </div>
                      {category?.combo_items?.map((_cItem, cItemIndex) => {
                        return (
                          <div
                            class="combo_item_list"
                            key={String(cItemIndex) + '_' + String(catIndex)}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="combo_item_name">
                                {_cItem?.item_name}
                              </div>
                              <div className="combo_item_selection">
                                <aside
                                  style={{
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                  className={`modifier-btn d-flex justify-content-between align-items-center ${
                                    isMobile ? 'flex-column' : 'flex-row'
                                  }`}
                                >
                                  <div
                                    className="mod_btn"
                                    style={{
                                      justifyContent: isMobile
                                        ? 'center'
                                        : undefined,
                                    }}
                                  >
                                    <span
                                      className={
                                        !_cItem?.quantity ? 'inactive' : ''
                                      }
                                      onClick={() => {
                                        if (
                                          !!fnb_item_id &&
                                          _cItem.item_id == fnb_item_id &&
                                          _cItem?.quantity <=
                                            scheduleDetails?.selectedSeats?.length
                                        ) {
                                          return;
                                        }
                                        onChangeComboItems(
                                          _cItem,
                                          cItemIndex,
                                          category,
                                          catIndex,
                                          'minus',
                                        );
                                      }}
                                    >
                                      <FnbRemove
                                        style={{ transform: 'scale(1.4)' }}
                                      />
                                    </span>
                                    <span
                                      className={`mx-3 ${
                                        !_cItem?.quantity ? 'inactive' : ''
                                      }`}
                                    >
                                      {_cItem?.quantity !== 0 && _cItem?.quantity
                                        ? _cItem?.quantity
                                        : '0'}
                                    </span>
                                    <span
                                      className="fnb_add_btn"
                                      onClick={() =>
                                        onChangeComboItems(
                                          _cItem,
                                          cItemIndex,
                                          category,
                                          catIndex,
                                          'add',
                                        )
                                      }
                                    >
                                      <FnbAdd style={{ transform: 'scale(1.4)' }} />
                                    </span>
                                  </div>
                                </aside>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="combo_container">
              <div className="text-center">No Items Found!</div>
            </div>
          )}
          <div className="combo_footer">
            <div className="btn-section d-flex justify-content-between align-items-center">
              <div
                className="btn-popup-sm"
                onClick={() => setShowComboEditPopup(false)}
              >
                Cancel
              </div>
              <div className="btn-popup-sm" onClick={() => onSaveComboChanges()}>
                Add To Cart
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <div className="mob_fnb_over_flow" style={{ overflow: 'hidden' }}>
        <div className="new_fnb_grid">
          <section
            className={`left_main-fnb  ${
              !isMobile && !isTablet ? 'col-md-4 col-xl-3' : ''
            }`}
          >
            {!isMobile && (
              <div className="left_fnb_grid" ref={movieInfoRef}>
                {/* Sidebar Section*/}
                <div className="sidebar_fnb fnb-order-details">
                  <p className={`title ${category_id == 1 && ' text-golden '}`}>
                    {t('My F&B ORDER')}
                  </p>
                  <section className="fnb_scroll">
                    {selectedFnbItems &&
                      selectedFnbItems.length > 0 &&
                      selectedFnbItems.map((selectedItem, itemIndex) => (
                        <>
                          <article
                            className="fnb-item-details"
                            key={selectedItem.item_id}
                          >
                            <p>
                              {getLangSpecificAttribute(
                                selectedItem?.FnbContent,
                                lang_id,
                                'item_lang_name',
                              ) || selectedItem.item_name}
                              {selectedItem?.hasOwnProperty('is_combo') &&
                                selectedItem?.is_combo == 'Y' && (
                                  <span
                                    className="btn btn-sm editCombo text-danger"
                                    onClick={() =>
                                      onEditCombo(selectedItem, itemIndex)
                                    }
                                  >
                                    (Customize)
                                  </span>
                                )}
                              {selectedItem.Quantity > 1 && (
                                <>
                                  &nbsp;
                                  <span>x{selectedItem.Quantity}</span>
                                  <p>
                                    {t('Single Item')} - {curr_code}{' '}
                                    {currencyFormatter(
                                      selectedItem.fp_total_amount,
                                    )}
                                  </p>
                                </>
                              )}
                            </p>
                            <p>
                              {curr_code}{' '}
                              {currencyFormatter(selectedItem.total_price)}
                            </p>
                          </article>
                          {selectedItem?.is_combo == 'Y' &&
                            selectedItem?.final_combo_array?.length &&
                            selectedItem?.final_combo_array?.map(
                              (comboItem, comboItemIndex) => {
                                return (
                                  <article
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      marginTop: '10px',
                                    }}
                                    className="combo-item-details"
                                    key={comboItem?.item_id}
                                  >
                                    <p className="text-left">
                                      {comboItem?.item_name}
                                    </p>
                                    <p>{comboItem?.quantity}x</p>
                                  </article>
                                );
                              },
                            )}
                        </>
                      ))}

                    {selectedFnbItems.length === 0 && (
                      <section
                        className="d-flex"
                        style={{
                          justifyContent: 'space-between',
                          fontSize: '12px',
                          paddingRight: '8px',
                        }}
                      >
                        {t('No Items Selected')}
                        <span>{curr_code} 00.00</span>
                      </section>
                    )}
                  </section>
                  <article className="fnb-total">
                    <p>{t('Total')}</p>
                    <p>
                      {curr_code} {currencyFormatter(fnbPrice.total_price)}
                    </p>
                  </article>
                  {/* {!isMobile && (
                  <button
                    className={`btn-main-new ${
                      category_id == 1 && ' golden_btn_pvt '
                    } ${selectedFnbItems?.length == 0 && ' inactive '}`}
                    onClick={() => {
                      proceedToPayment();
                    }}
                  >
                    {selectedFnbItems.length > 0
                      ? t('Proceed')
                      : t(
                          // "Skip"
                          'Proceed',
                        )}
                  </button>
                )} */}
                </div>
                {/* Booking Section*/}
                <div className="title_n_value">
                  <h6 className={`${category_id == 1 && ' text-golden '}`}>
                    {t('Booking Summary').toUpperCase()}
                  </h6>
                  <article className="payment_details_rows">
                    {seatTypes?.length > 0 &&
                      seatTypes?.map((seatType, seatTypeIndex) => (
                        <React.Fragment key={seatTypeIndex}>
                          {seatType?.seats?.length > 0 &&
                            seatType?.seats?.map((rcg_child, index2) => (
                              <section className="good" key={index2}>
                                <p className="left_value">
                                  <span className="ml-0">
                                    (x{rcg_child.no_of_seats} {t('Seats')})
                                  </span>
                                  &nbsp;
                                  <>{seatType.sst_seat_type}</>
                                  {/* <p>
                                  <span className="">
                                    {rcg_child?.ticket_type_translations?.[
                                      iso_2?.toLowerCase()
                                    ] || rcg_child.tt_name}
                                  </span>
                                </p> */}
                                </p>

                                <p className="right_value">
                                  {curr_code}{' '}
                                  {currencyFormatter(rcg_child?.total_price)}
                                </p>
                              </section>
                            ))}
                        </React.Fragment>
                      ))}
                    {scheduleDetails?.booking_type_id == 3 ? (
                      <>
                        <section className="good">
                          <div className="left_value">
                            {scheduleDetails?.screen_name}
                          </div>
                          <div className="right_value">
                            {!!ticket_count
                              ? `(x${ticket_count}):`
                              : `(x${scheduleDetails?.ticket_count}):`}
                          </div>
                        </section>
                        <section className="">
                          <div className="left_value">
                            {scheduleDetails?.booking_type_name}
                          </div>
                          <div className="right_value">
                            {curr_code}{' '}
                            {currencyFormatter(reservationDetails?.amount)}
                          </div>
                        </section>
                      </>
                    ) : (
                      <>
                        {/* <section className="">
                <div className="left_value">{scheduleDetails?.seat_name}</div>
                <div className="right_value">{curr_code}{" "}{currencyFormatter(reservationDetails?.amount)}</div>
                    </section> */}
                      </>
                    )}
                  </article>
                  {/* Gross addons on rate card */}
                  {add_ons_array?.[0]?.gross_amount_addons?.length > 0 && (
                    <div className="payment_details_rows" id="grossAddonsDetails">
                      <section className="good">
                        <div className="left_value">{t('Addons')}</div>
                        <div className="right_value"></div>
                      </section>

                      {add_ons_array?.[0]?.gross_amount_addons?.map((item) => (
                        <section className="good">
                          <div className="left_value">
                            {item.quantity && <span>(x{item.quantity}) </span>}
                            {t(item.addons_name) || item.addons_name}
                          </div>
                          <div className="right_value">
                            {curr_code} {currencyFormatter(item?.final_price)}
                          </div>
                        </section>
                      ))}

                      <section className="good">
                        <div className="left_value">
                          {t('Addons')} {t('Total')}
                        </div>
                        <div className="right_value">
                          {curr_code}{' '}
                          {currencyFormatter(getRateCardAddonsTotal(add_ons_array))}
                        </div>
                      </section>
                    </div>
                  )}

                  {/* {selectedFnbItems && selectedFnbItems.length > 0 && (
            <article className="grey-title-lg mb-2">
              {t("Concessions")}
            </article>
          )} */}

                  {isMobile && selectedFnbItems && selectedFnbItems.length > 0 && (
                    <div className="payment_details_rows">
                      {selectedFnbItems.map((item, index) => (
                        <section className="good" key={index}>
                          <div className="left_value">
                            {item.Quantity && <span>(x{item.Quantity}) </span>}

                            {getLangSpecificAttribute(
                              item?.FnbContent,
                              lang_id,
                              'item_lang_name',
                            ) || item.item_name}
                          </div>
                          <div className="right_value">
                            {curr_code} {currencyFormatter(item.fp_total_amount)}
                          </div>
                        </section>
                      ))}
                    </div>
                  )}

                  {discount && (
                    <div className="payment_details_rows text-success">
                      <section className="good">
                        <div className="left_value"> {t('Discount')}: </div>
                        <div className="right_value">
                          {' '}
                          - {curr_code} {currencyFormatter(discount)}
                        </div>
                      </section>
                    </div>
                  )}
                  {getInternetHandlingFees(
                    category_id,
                    is_internet_handling_enable,
                    scheduleDetails,
                    reservationDetails,
                  ) > 0 && (
                    <div className="payment_details_rows">
                      <section className="good">
                        <div className="left_value">
                          {' '}
                          {t('Internet Handling Fee')}
                        </div>
                        <div className="right_value">
                          {' '}
                          {curr_code}{' '}
                          {currencyFormatter(
                            getInternetHandlingFees(
                              category_id,
                              is_internet_handling_enable,
                              scheduleDetails,
                              reservationDetails,
                            ),
                          )}
                        </div>
                      </section>
                    </div>
                  )}
                </div>
                <div>
                  {!isMobile && showElement && (
                    <button
                      style={{
                        marginLeft: '20px',
                        backgroundColor: 'var(--blue)',
                        margin: 'auto',
                        color: 'white',
                      }}
                      className={`btn-main-new ${
                        category_id == 1 && ' golden_btn_pvt '
                      } ${selectedFnbItems?.length == 0 && ' inactive '}`}
                      onClick={() => {
                        proceedToPayment();
                      }}
                    >
                      {selectedFnbItems.length > 0
                        ? t('Proceed')
                        : t(
                            // "Skip"
                            'Skip To Checkout',
                          )}
                    </button>
                  )}
                </div>
                <article ref={movieInfoRef}>
                  <div
                    className={`movie-bottom ${
                      category_id == 1 && ' movie-bottom-gold '
                    }}`}
                  >
                    <section className="">
                      <div className="">
                        <h5 className="text_fnb_bold">{t('Grand Total')}</h5>
                        <h4 className="text_fnb_bold">
                          {curr_code}{' '}
                          {currencyFormatter(
                            reservationDetails?.amount +
                              fnbPrice.total_price -
                              (discount ? discount : 0) +
                              getRateCardAddonsTotal(add_ons_array) +
                              getInternetHandlingFees(
                                category_id,
                                is_internet_handling_enable,
                                scheduleDetails,
                                reservationDetails,
                              ),
                          )}
                        </h4>
                      </div>
                      <h6>
                        {' '}
                        Prices Including VAT
                        {/* {t('(Incl. of 2.5% VAT - ')} {curr_code}{' '}
                      {currencyFormatter(
                        _.round(
                          percentage(
                            2.5,
                            reservationDetails?.amount +
                              fnbPrice.total_price -
                              (discount ? discount : 0) +
                              getRateCardAddonsTotal(add_ons_array) +
                              getInternetHandlingFees(
                                category_id,
                                is_internet_handling_enable,
                                scheduleDetails,
                                reservationDetails,
                              ),
                          ),
                          4,
                        ),
                      )}{' '}
                      {')'} */}
                      </h6>
                    </section>
                  </div>
                </article>
              </div>
            )}
          </section>
          {/*Right Section */}
          <div className="right_fnb_grid col-xl-9 col-md-7 col-lg-8">
            {/* Progress Bar Section*/}
            <div className="progress_fnb inner_pages_header_fnb">
              <div
                className={`${category_id == 1 ? 'gold_go_back' : 'go_back'}`}
                onMouseOver={() => setBack(true)}
                onMouseOut={() => setBack(false)}
                onClick={goToSeatLayout}
              >
                <LeftArrow />
              </div>
              <div className="custom_breadcrumbs_fnb">
                <div className="steps_new">
                  <span className=" bor_new1">
                    {category_id == 1
                      ? t('Private Cinema Booking')
                      : `${t('Now Showing')}`}
                  </span>

                  <span
                    className={`mx-3 ${
                      category_id == 1 ? 'bor_new_pvt' : 'bor_new'
                    }`}
                  >
                    {t('Food & Beverages')}
                  </span>
                  <span className="bor_new1">{t('Checkout')}</span>
                </div>

                {/*<span onClick={()=>history.push("/now-showing")}>
                  Now Showing</span> <span>
              Now Showing Booking</span> */}
              </div>

              <div />
            </div>
            {/* Main Section*/}
            <div className="king" style={{ marginLeft: '0px' }}>
              <div className="food">
                <h4 className="bev">{t('Select Food and Beverage')}</h4>
                {isMobile ? (
                  <button
                    className={`check_out_mob ${
                      category_id == 1 && ' golden_btn_pvt '
                    }`}
                    onClick={() => {
                      proceedToPayment(true);
                    }}
                  >
                    {t('Skip')}
                  </button>
                ) : (
                  showElement && (
                    <button
                      className={`check_out ${
                        category_id == 1 && ' golden_btn_pvt '
                      }`}
                      onClick={() => {
                        proceedToPayment(true);
                      }}
                    >
                      {t('Skip to checkout ?')}
                    </button>
                  )
                )}
              </div>
              <div className="sch">
                <label className="fnb-search">
                  <img
                    src={searchIcon}
                    alt="search"
                    onClick={(e) => e.target.nextElementSibling.focus()}
                  />
                  <input
                    type="text"
                    placeholder={t('Search for concessions')}
                    // autoFocus
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      border:
                        category_id == 1
                          ? '1px solid var(--yellow-shade)'
                          : '1px solid #1f1c3c',
                    }}
                  />
                  <img
                    src={close}
                    alt="close"
                    className={`${search ? 'show' : ''}`}
                    onClick={() => setSearch('')}
                  />
                </label>
                {/* <section className="ments">
                  <button
                    className={`fnb-category-btn ${selectedCategory === '' ? 'selected' : ''
                      }`}
                    onClick={() => setSelectedCategory('')}
                  >
                    {t('All')}
                  </button>
                  {fnbCategoriesuniqueArray &&
                    fnbCategoriesuniqueArray.length > 0 &&
                    fnbCategoriesuniqueArray
                      ?.sort(
                        (a, b) => parseFloat(a.fc_order) - parseFloat(b.fc_order),
                      )
                      .map((category, categoryIndex) => (
                        <button
                          key={categoryIndex}
                          className={`fnb-category-btn  ${selectedCategory?.fc_id === category?.fc_id
                            ? 'selected'
                            : ''
                            }`}
                          onClick={() => setSelectedCategory(category)}
                        >
                          {getLangSpecificAttribute(
                            category?.FnbCategoryContent,
                            lang_id,
                            'category_lang_name',
                          ) || category.fc_category}
                        </button>
                      ))}
                </section> */}
                <section className="ments">
                  {fnbCategoriesuniqueArray &&
                    fnbCategoriesuniqueArray.length > 0 &&
                    fnbCategoriesuniqueArray
                      .sort(
                        (a, b) => parseFloat(a.fc_order) - parseFloat(b.fc_order),
                      )
                      .map((category, categoryIndex) => (
                        <button
                          key={categoryIndex}
                          className={`fnb-category-btn ${
                            categoryIndex === 0 && !selectedCategory
                              ? 'selected'
                              : ''
                          } 
                      ${
                        selectedCategory &&
                        selectedCategory.fc_id === category.fc_id
                          ? 'selected'
                          : ''
                      }`}
                          onClick={() => setSelectedCategory(category)}
                        >
                          {getLangSpecificAttribute(
                            category?.FnbCategoryContent,
                            lang_id,
                            'category_lang_name',
                          ) || category.fc_category}
                        </button>
                      ))}
                </section>
              </div>
            </div>
            {/* Product Section*/}
            <div className="fnb_card_main">
              {visibleFnbItems && visibleFnbItems.length > 0 ? (
                <>
                  {visibleFnbItems.map((item, index) => (
                    <FnbCard
                      scheduleDetails={scheduleDetails}
                      fnb_item_id={fnb_item_id}
                      key={index}
                      item={item}
                      t={t}
                      allSelectedFnbItem={selectedFnbItems || []}
                      selectedFnbItem={(selectedFnbItems || []).filter(
                        (sf) => item?.item_id == sf?.item_id,
                      )}
                    />
                  ))}
                </>
              ) : (
                <div className="row justify-content-center align-items-center no_item">
                  {t('No Items Found')}
                </div>
              )}
            </div>
          </div>
        </div>

        {/*New Fnb Design */}

        {/*Fnb Old design */}
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <section className="inner_pages_header_fnb" style={{ display: 'none' }}>
              <GoBack
                onMouseOver={() => setBack(true)}
                onMouseOut={() => setBack(false)}
                onClick={goToSeatLayout}
              />
              <div className="custom_breadcrumbs_fnb">
                <div className="steps_new">
                  <span className=" bor_new1">
                    {category_id == 1
                      ? t('Private Cinema Booking')
                      : t('Now Showing Booking')}
                  </span>

                  <span
                    className={`mx-3 ${
                      category_id == 1 ? 'bor_new_pvt' : 'bor_new'
                    }`}
                  >
                    {t('Food & Beverages')}
                  </span>
                  <span className="bor_new1">{t('Checkout')}</span>
                </div>

                {/*<span onClick={()=>history.push("/now-showing")}>
                  Now Showing</span> <span>
              Now Showing Booking</span> */}
              </div>

              <div />
            </section>

            {/*<div className="gain">

            {/*<button
              className="btn-main-back  mt-2"
              onMouseOver={() => setBack(true)}
              onMouseOut={() => setBack(false)}
              onClick={goToSeatLayout}
            >*/}
            {/* <img
                src={back ? arrowBackActive : arrowBack}
                className="mr3"
                alt=""
              /> */}
            {/*<ArrowLeftOutlined /><span style={{ color: "white", fontSize: "14px", paddingLeft: "10px" }}>Back</span>*/}

            {/* Back
            {/*</button>
              onClick={goToSeatLayout}
            />
            <div className="name_new" style={{ borderBottom: "1px solid #2f2e31" }}>
              <span style={{ color: "#2f2e31" }} className="px-4">
                {t("Now Showing")?.toUpperCase()}
              </span>
              <span style={{ color: "white", borderBottom: "2px solid #e8308a" }} className="px-4">
                {t('Food & Beverages')?.toUpperCase()}
              </span>
              <span style={{ color: "#2f2e31" }} className="px-4">
                {t("Checkout")?.toUpperCase()}
              </span>
            </div>
          </div>


*/}
          </Col>
        </Row>
        <Col span={24}>
          <Row gutter={[32, 32]}>
            {/*<Col span={6} className="v_b">

            <section
              className={`fnb-order-details ${isMobile ? "mb-2" : "mb-3"} col-xl-3`}
              style={{ marginLeft: "18px" }}>
              <p className={`title ${category_id == 1 && ' text-golden '}`}>{t("My F&B ORDER")}</p>
              <section className="fnb_scroll">
                {selectedFnbItems &&
                  selectedFnbItems.length > 0 &&
                  selectedFnbItems.map((selectedItem) => (
                    <article
                      className="fnb-item-details"
                      key={selectedItem.item_id}
                    >
                      <p>
                        {getLangSpecificAttribute(
                          selectedItem?.FnbContent,
                          lang_id,
                          "item_lang_name"
                        ) || selectedItem.item_name}
                        {selectedItem.Quantity > 1 && (
                          <>
                            &nbsp;
                            <span>x{selectedItem.Quantity}</span>
                            <p>
                              {t("Single Item")} - {curr_code}{" "}
                              {currencyFormatter(
                                selectedItem.fp_total_amount
                              )}
                            </p>
                          </>
                        )}
                      </p>
                      <p>
                        {curr_code}{" "}
                        {currencyFormatter(selectedItem.total_price)}
                      </p>
                    </article>
                  ))}
                {selectedFnbItems.length === 0 && (
                  <section className="d-flex" style={{justifyContent:"space-between",fontSize:"12px",paddingRight:"8px"}}>
                    {t("No Items Selected")}
                    <span>{curr_code}{" "}00.00</span>
                  </section>
                )}
              </section>
              <article className="fnb-total">
                <p>{t("Total")}</p>
                <p>
                  {curr_code} {currencyFormatter(fnbPrice.total_price)}
                </p>
              </article>
              {!isMobile && (
                <button
                  className={`btn-main-new ${category_id == 1 && ' golden_btn_pvt '}`}
                  onClick={() => {
                    proceedToPayment();
                  }}
                >
                  {selectedFnbItems.length > 0 ? t("Proceed") : t("Skip")}
                </button>
              )}


            </section>
                </Col>*/}

            {/*<Col span={18}>
            <div className="king col-xl-9">

              <div className="food">
                <h4 className="bev">{t("Select Food and Beverage")}
                </h4>
                {
                  isMobile
                    ? <button className={`check_out_mob mx-auto ${category_id == 1 && ' golden_btn_pvt '}`} onClick={() => { proceedToPayment() }}>{t("Skip")}</button>
                    : <button className={`check_out ${category_id == 1 && ' golden_btn_pvt '}`} onClick={() => { proceedToPayment() }}>{t("Skip to checkout ?")}</button>
                }

              </div>
              <div className="sch">
                <label className="fnb-search">
                  <img
                    src={searchIcon}
                    alt="search"
                    onClick={(e) => e.target.nextElementSibling.focus()}
                  />
                  <input
                    type="text"
                    placeholder={t("Search for concessions")}
                    // autoFocus
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      border: category_id == 1 ? '1px solid var(--yellow-shade)' : '1px solid var(--primary)'
                    }}
                  />
                  <img
                    src={close}
                    alt="close"
                    className={`${search ? "show" : ""}`}
                    onClick={() => setSearch("")}
                  />
                </label>
                <section className="ments">
                  <button
                    className={`fnb-category-btn ${
                      selectedCategory === "" ? "selected" : ""
                    }`}
                    onClick={() => setSelectedCategory("")}
                  >
                    {t("All")}
                  </button>
                  {fnbCategories &&
                    fnbCategories.length > 0 &&
                    fnbCategories.map((category, categoryIndex) => (
                      <button
                        key={categoryIndex}
                        className={`fnb-category-btn  ${
                          selectedCategory === category ? "selected" : ""
                        }`}
                        onClick={() => setSelectedCategory(category)}
                      >
                        {getLangSpecificAttribute(
                          category?.FnbCategoryContent,
                          lang_id,
                          "category_lang_name"
                        ) || category.fc_category}
                      </button>

                    ))}

                </section>
              </div>
            </div>
                        </Col>*/}
          </Row>
        </Col>

        <div
          className="container-fluid container-xl header-space "
          style={{ paddingLeft: '0px' }}
        >
          {/*<p className="mx-auto big-heading text-md-center for-prev-step">
          {/*<div className="prev-step">
            <button
              className="btn-main mx-auto mt-2"
              onMouseOver={() => setBack(true)}
              onMouseOut={() => setBack(false)}
              onClick={goToSeatLayout}
            >
              {/* <img
                src={back ? arrowBackActive : arrowBack}
                className="mr3"
                alt=""
              /> }
                              {/*{back ? <ArrowBackActive/> : <ArrowBack/>}}

              {/* Back }
            </button>
            </div>}
          {t("Concessions")}
        </p>*/}

          {/* <section className="row justify-content-center for-prev-step">
          <div className="prev-step">
            <button
              className="btn-main mx-auto mt-3 mt-xl-4"
              onMouseOver={() => setBack(true)}
              onMouseOut={() => setBack(false)}
            >
              <img
                src={back ? arrowBackActive : arrowBack}
                className="mr3"
                alt=""
              /> */}
          {/* Back */}
          {/* </button>
          </div> */}

          {/* <div className="col-sm-9 mx-auto">
            <div className="steps">
              <div className={`step ticket complete`}></div>
              <div className={`step screen complete`}></div>
              <div className={`step seat complete`}></div>
            </div>
          </div> */}
          {/* </div> */}
          {/* </section> */}

          {/*<section className="row mb-3">
          <article className="col-10 col-md-6 col-lg-5 col-xl-3">
            <label className="fnb-search">
              <img
                src={searchIcon}
                alt="search"
                onClick={(e) => e.target.nextElementSibling.focus()}
              />
              <input
                type="text"
                placeholder={t("Search for concessions")}
                autoFocus
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <img
                src={close}
                alt="close"
                className={`${search ? "show" : ""}`}
                onClick={() => setSearch("")}
              />
            </label>
          </article>
        </section>*/}

          <section className="row">
            <article className="col-12">
              {/* <section className="row align-items-center">
              <article className="col-lg-6 order-1 order-md-0"> */}
              {/*<div className="inline-scrollable">
              <section>
                <button
                  className={`fnb-category-btn ${
                    selectedCategory === "" ? "selected" : ""
                  }`}
                  onClick={() => setSelectedCategory("")}
                >
                  {t("All")}
                </button>
                {fnbCategories &&
                  fnbCategories.length > 0 &&
                  fnbCategories.map((category, categoryIndex) => (
                    <button
                      key={categoryIndex}
                      className={`fnb-category-btn ${
                        selectedCategory === category ? "selected" : ""
                      }`}
                      onClick={() => setSelectedCategory(category)}
                    >
                      {getLangSpecificAttribute(
                        category?.FnbCategoryContent,
                        lang_id,
                        "category_lang_name"
                      ) || category.fc_category}
                    </button>
                  ))}
              </section>
                      </div>*/}
              {/* </article> */}
              {/* <article className="col-lg-6 mb-3 mb-md-0">
                <label className="fnb-search">
                  <img
                    src={search}
                    alt="search"
                    onClick={(e) => e.target.nextElementSibling.focus()}
                  />
                  <input
                    type="search"
                    placeholder="Search for concessions"
                    autoFocus
                  />
                </label>
              </article> */}
              {/* </section> */}
            </article>
          </section>

          <section className="row fnb-row">
            <article className="col-md-5 col-xl-3 fnb-mobile-bar">
              {!footerAccordion && isMobile && (
                <>
                  <div className="title_n_value">
                    <h6 className={`${category_id == 1 && ' text-golden '}`}>
                      {t('Booking Summary').toUpperCase()}
                    </h6>
                    <article className="payment_details_rows">
                      {seatTypes?.length > 0 &&
                        seatTypes?.map((seatType, seatTypeIndex) => (
                          <React.Fragment key={seatTypeIndex}>
                            {seatType?.seats?.length > 0 &&
                              seatType?.seats?.map((rcg_child, index2) => (
                                <section className="good" key={index2}>
                                  <p className="left_value">
                                    <span className="ml-0">
                                      (x{rcg_child.no_of_seats} {t('Seats')})
                                    </span>
                                    &nbsp;
                                    {/* <>{seatType.sst_seat_type}</> */}
                                    {/* <span className="">
                                    {rcg_child?.ticket_type_translations?.[
                                      iso_2?.toLowerCase()
                                    ] || rcg_child.tt_name}
                                  </span> */}
                                  </p>

                                  <p className="right_value">
                                    {curr_code}{' '}
                                    {currencyFormatter(rcg_child?.total_price)}
                                  </p>
                                </section>
                              ))}
                          </React.Fragment>
                        ))}
                      {scheduleDetails?.booking_type_id == 3 ? (
                        <>
                          <section className="good">
                            <div className="left_value">
                              {scheduleDetails?.screen_name}
                            </div>
                            <div className="right_value">
                              {!!ticket_count
                                ? `(x${ticket_count}):`
                                : `(x${scheduleDetails?.ticket_count}):`}
                            </div>
                          </section>
                          <section className="">
                            <div className="left_value">
                              {scheduleDetails?.booking_type_name}
                            </div>
                            <div className="right_value">
                              {curr_code}{' '}
                              {currencyFormatter(reservationDetails?.amount)}
                            </div>
                          </section>
                        </>
                      ) : (
                        <>
                          {/* <section className="">
                <div className="left_value">{scheduleDetails?.seat_name}</div>
                <div className="right_value">{curr_code}{" "}{currencyFormatter(reservationDetails?.amount)}</div>
                    </section> */}
                        </>
                      )}
                    </article>
                    {/* Gross addons on rate card */}
                    {add_ons_array?.[0]?.gross_amount_addons?.length > 0 && (
                      <div className="payment_details_rows" id="grossAddonsDetails">
                        <section className="good">
                          <div className="left_value">{t('Addons')}</div>
                          <div className="right_value"></div>
                        </section>

                        {add_ons_array?.[0]?.gross_amount_addons?.map((item) => (
                          <section className="good">
                            <div className="left_value">
                              {item.quantity && <span>(x{item.quantity}) </span>}
                              {t(item.addons_name) || item.addons_name}
                            </div>
                            <div className="right_value">
                              {curr_code} {currencyFormatter(item?.final_price)}
                            </div>
                          </section>
                        ))}

                        <section className="good">
                          <div className="left_value">
                            {t('Addons')} {t('Total')}
                          </div>
                          <div className="right_value">
                            {curr_code}{' '}
                            {currencyFormatter(
                              getRateCardAddonsTotal(add_ons_array),
                            )}
                          </div>
                        </section>
                      </div>
                    )}
                    {/* {selectedFnbItems && selectedFnbItems.length > 0 && (
            <article className="grey-title-lg mb-2">
              {t("Concessions")}
            </article>
          )} */}

                    {isMobile &&
                      selectedFnbItems &&
                      selectedFnbItems.length > 0 && (
                        <div className="payment_details_rows">
                          {selectedFnbItems.map((item, index) => (
                            <section className="good" key={index}>
                              <div className="left_value">
                                {item.Quantity && <span>(x{item.Quantity}) </span>}

                                {getLangSpecificAttribute(
                                  item?.FnbContent,
                                  lang_id,
                                  'item_lang_name',
                                ) || item.item_name}
                              </div>
                              <div className="right_value fnbValue">
                                {curr_code}{' '}
                                {currencyFormatter(
                                  item.Quantity * item.fp_total_amount,
                                )}
                              </div>
                            </section>
                          ))}
                        </div>
                      )}

                    {discount && (
                      <div className="payment_details_rows text-success">
                        <section className="good">
                          <div className="left_value"> {t('Discount')}: </div>
                          <div className="right_value">
                            {' '}
                            - {curr_code} {currencyFormatter(discount)}
                          </div>
                        </section>
                      </div>
                    )}
                    {getInternetHandlingFees(
                      category_id,
                      is_internet_handling_enable,
                      scheduleDetails,
                      reservationDetails,
                    ) > 0 && (
                      <div className="payment_details_rows">
                        <section className="good">
                          <div className="left_value">
                            {' '}
                            {t('Internet Handling Fee')}
                          </div>
                          <div className="right_value">
                            {' '}
                            {curr_code}{' '}
                            {currencyFormatter(
                              getInternetHandlingFees(
                                category_id,
                                is_internet_handling_enable,
                                scheduleDetails,
                                reservationDetails,
                              ),
                            )}
                          </div>
                        </section>
                      </div>
                    )}

                    {/*<div className="payment_details_rows payment_details_total">
                 <section className="">
                <h5>{t("Grand Total")}

              </h5>
              <h4 className="">
                  {curr_code}{" "}
            {currencyFormatter(
              reservationDetails?.amount +
              fnbPrice.total_price -
              (discount ? discount : 0)
            )}
                </h4>



            </section>
            <h6>
                {t("(Incl. of 2.5% VAT - ")} {curr_code}{" "}
            {currencyFormatter(
              _.round(
                percentage(
                  2.5,
                  reservationDetails?.amount +
                  fnbPrice.total_price -
                  (discount ? discount : 0)
                ),
                4
              )
            )}{" "}
                  {")"}
          </h6>
                </div>*/}
                  </div>

                  <div className="movie_info_scroll_space" />

                  <article
                    className={`movie-bottom ${
                      category_id == 1 && ' movie-bottom-gold '
                    }}`}
                    ref={movieBottomRef}
                    style={{ display: 'none' }}
                  >
                    <section className="">
                      <div>
                        <h5 className="text_fnb_bold">
                          <b>{t('Grand Total')}</b>
                        </h5>
                        <h4 className="text_fnb_bold">
                          {curr_code}{' '}
                          {currencyFormatter(
                            reservationDetails?.amount +
                              fnbPrice.total_price -
                              (discount ? discount : 0) +
                              getRateCardAddonsTotal(add_ons_array) +
                              getInternetHandlingFees(
                                category_id,
                                is_internet_handling_enable,
                                scheduleDetails,
                                reservationDetails,
                              ),
                          )}
                        </h4>
                      </div>
                      <h6>
                        Prices Including VAT
                        {/* {t('(Incl. of 2.5% VAT - ')} {curr_code}{' '}
                      {currencyFormatter(
                        _.round(
                          percentage(
                            2.5,
                            reservationDetails?.amount +
                              fnbPrice.total_price -
                              (discount ? discount : 0) +
                              getRateCardAddonsTotal(add_ons_array) +
                              getInternetHandlingFees(
                                category_id,
                                is_internet_handling_enable,
                                scheduleDetails,
                                reservationDetails,
                              ),
                          ),
                          4,
                        ),
                      )}{' '}
                      {')'} */}
                      </h6>
                    </section>

                    {/* <div className="img-top">
          <img
            src={circles}
            alt="Arrow Down"
          />
        </div> */}
                  </article>

                  {/*<section
                  className={`fnb-order-details ${isMobile ? "mb-2" : "mb-3"}`}
                >
                  <p className="title">{t("Your order details")}</p>
                  {selectedFnbItems &&
                    selectedFnbItems.length > 0 &&
                    selectedFnbItems.map((selectedItem) => (
                      <article
                        className="fnb-item-details"
                        key={selectedItem.item_id}
                      >
                        <p>
                          {getLangSpecificAttribute(
                            selectedItem?.FnbContent,
                            lang_id,
                            "item_lang_name"
                          ) || selectedItem.item_name}
                          {selectedItem.Quantity > 1 && (
                            <>
                              &nbsp;
                              <span>x{selectedItem.Quantity}</span>
                              <p>
                                {t("Single Item")} - {curr_code}{" "}
                                {currencyFormatter(
                                  selectedItem.fp_total_amount
                                )}
                              </p>
                            </>
                          )}
                        </p>
                        <p>
                          {curr_code}{" "}
                          {currencyFormatter(selectedItem.total_price)}
                        </p>
                      </article>
                    ))}
                  {selectedFnbItems.length === 0 && (
                    <section className="d-flex justify-content-center align-items-center">
                      {t("No Items Selected")}
                    </section>
                  )}
                  <article className="fnb-total">
                    <p>{t("Total")}</p>
                    <p>
                      {curr_code} {currencyFormatter(fnbPrice.total_price)}
                    </p>
                  </article>
                  </section>
                {!isMobile && (
                  <button
                    className="btn-main mx-auto"
                    onClick={() => {
                      proceedToPayment();
                    }}
                  >
                    {selectedFnbItems.length > 0 ? t("Confirm") : t("Skip")}
                  </button>
                )}*/}
                </>
              )}
              {isMobile && (
                <article className={`pay_now ${category_id == 1 && ' back_gold '}`}>
                  {/*row align-items-center black*/}
                  <div className="col-6 total_fnb">
                    <p style={{ fontSize: '14px' }}>
                      <b>{t('Total Payable')}</b>
                    </p>
                    <p style={{ fontSize: '9px' }}>
                      Prices Including VAT
                      {/* {t('(Incl. of 2.5% VAT - ')} {curr_code}{' '}
                    {currencyFormatter(
                      _.round(
                        percentage(
                          2.5,
                          reservationDetails?.amount +
                            fnbPrice.total_price -
                            (discount ? discount : 0) +
                            getRateCardAddonsTotal(add_ons_array) +
                            getInternetHandlingFees(
                              category_id,
                              is_internet_handling_enable,
                              scheduleDetails,
                              reservationDetails,
                            ),
                        ),
                        4,
                      ),
                    )}{' '}
                    {')'} */}
                    </p>
                    {/*<p className="fnb-item-count">
                    {selectedFnbItems.length} {t("Items selected")}
            </p>*/}
                    <p className="">
                      {curr_code}{' '}
                      {currencyFormatter(
                        reservationDetails?.amount +
                          fnbPrice.total_price -
                          (discount ? discount : 0) +
                          getRateCardAddonsTotal(add_ons_array) +
                          getInternetHandlingFees(
                            category_id,
                            is_internet_handling_enable,
                            scheduleDetails,
                            reservationDetails,
                          ),
                      )}
                    </p>
                  </div>
                  <div className="col-6 col-xs-8  for-ft">
                    <button
                      className={`btn-main footer ${
                        category_id == 1 ? 'gold_hov text-golden ' : ``
                      }`}
                      onClick={() => {
                        proceedToPayment();
                      }}
                    >
                      {selectedFnbItems.length > 0 ? t('Pay Now') : t('Skip')}
                    </button>
                    <div
                      className={`footer-toggle ${
                        category_id == 1 && ' golden-footer-fig '
                      }`}
                    >
                      <figure
                        className={`${!footerAccordion ? 'ft-rotate' : ''}`}
                        onClick={() => {
                          footerAccordion
                            ? setFooterAccordion(false)
                            : setFooterAccordion(true);
                        }}
                      >
                        <NewDropDownArrow />
                      </figure>
                    </div>
                  </div>
                </article>
              )}
            </article>
            <article
              className={`col-md-7 col-xl-9 ${
                false && !isMobile ? 'fnb-items' : ''
              }`}
            >
              {fnbItemsLoader && (
                <div className="row d-flex align-items-center justify-content-center">
                  <Spinner />
                </div>
              )}
              {/* {!fnbItemsLoader &&
              (fnbItemsWithSearch && fnbItemsWithSearch.length > 0 ? (
                <div className="row boing" style={{ paddingLeft: "50px" }}>
                  {fnbItemsWithSearch.map((item, index) => (
                    <FnbCard
                      scheduleDetails={scheduleDetails}
                      fnb_item_id={fnb_item_id}
                      key={index}
                      item={item}
                      t={t}
                      selectedFnbItem={(selectedFnbItems || []).filter(
                        (sf) => item?.item_id == sf?.item_id
                      )}
                    />
                  ))}
                </div>
              ) : (
                <div className="row justify-content-center align-items-center">
                  {t("No Items Found")}
                </div>
              ))} */}
            </article>
          </section>
        </div>
      </div>
    </>
  );
};

function FnbCard({
  item,
  t,
  selectedFnbItem,
  fnb_item_id,
  scheduleDetails,
  allSelectedFnbItem = [],
}) {
  // console.log(item, 'itemmmmm');
  const { ss_id, screen_id, md_id, mycinema_ss_d_id, booking_type_id } =
    useParams();
  let category_id = ss_id && screen_id && md_id ? 2 : 1;

  const isMobile = useIsMobile();
  const [index, setIndex] = useState(0);

  const dispatch = useDispatch();
  const [tempSelectedFnb, setTempSelectedFnb] = useState(null);
  const [showAlternatePopup, setAlternatePopup] = useState(false);
  const [showComboPopup, setComboPopup] = useState(false);
  const [showCustomizationPopup, setCustomizationPopup] = useState(false);
  const [tempItemCount, setTempItemCount] = useState(0);
  const [tempComboAction, setTempComboAction] = useState('add');
  const [clickAddExtra, setClickAddExtra] = useState(false);

  useEffect(() => {
    if (
      tempSelectedFnb &&
      tempSelectedFnb?.alternate_items &&
      tempSelectedFnb?.alternate_items?.length &&
      !clickAddExtra
    ) {
      setAlternatePopup(true);
    } else if (
      tempSelectedFnb &&
      tempSelectedFnb?.customizationItemsList &&
      tempSelectedFnb?.customizationItemsList?.length
    ) {
      setCustomizationPopup(true);
    } else {
      setAlternatePopup(false);
    }
    setClickAddExtra(false);
  }, [tempSelectedFnb]);

  const fetchAlternateFnbItemData = async (item) => {
    try {
      if (
        item?.hasOwnProperty('alternate_items') &&
        item?.alternate_items?.length
      ) {
        setTempSelectedFnb(item);
        setAlternatePopup(true);
      } else {
        let payload = {
          item_id: item?.item_id,
          cinema_id: scheduleDetails?.cinema_id,
        };
        const response = await FnbService.AlternateFnbItems(payload);
        const { data } = response;
        let temArr = [];
        if (data?.status) {
          data?.Records.forEach((data) => {
            let temp = {
              Quantity: 0,
              quantity: 0,
              FnbCategoryContent: [],
              FnbContent: [],
              alternate_items: [],
              final_modifier_array: [],
              final_combo_array: [],
              combo_pack: [],
              customization_items: [],
              customizationItemsList: [],
              alternate_item_for: item?.item_id,
              ...data,
            };
            item['alternate_items'].push(temp);
          });
          setTempSelectedFnb(item);
        } else {
          setTempSelectedFnb(item);
        }
      }
    } catch (error) {
      console.error(error);
      setTempSelectedFnb(item);
    }
  };
  const onFetchCustomizations = async (_item) => {
    try {
      if (
        _item?.hasOwnProperty('customizationItemsList') &&
        _item?.customizationItemsList?.length
      ) {
        setTempSelectedFnb(_item);
        setCustomizationPopup(true);
      } else {
        let payload = {
          cinema_id: scheduleDetails?.cinema_id,
          specificItems: _item?.customization_items,
          is_customization: 'Y',
        };
        const { data } = await FnbService.GetAllFnbItems(payload);
        if (
          data.status &&
          data.Records &&
          data.Records.Records &&
          data.Records.Records.length > 0
        ) {
          data?.Records?.Records.forEach((data) => {
            let temp = {
              Quantity: 0,
              quantity: 0,
              customized_for_fnb_id: _item?.item_id,
              alternate_items: [],
              ...data,
            };
            _item['customizationItemsList'].push(temp);
          });
          setTempSelectedFnb(_item);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const currency = useSelector((state) => state.movies.currency);
  const { curr_code, curr_id } = currency;

  // const onSelectFnbItem = (type, item) => {
  //   dispatch(onSelectFnb(type, item));
  // };
  const onSelectFnbItem = (type, item) => {
    setTempComboAction(type);
    if (
      item?.hasOwnProperty('is_customization_available') &&
      item?.is_customization_available == 'Y' &&
      item?.customization_items?.length &&
      type == 'add' &&
      getCountArray(allSelectedFnbItem, item) < 1
    ) {
      onFetchCustomizations(item);
    }
    if (
      item?.hasOwnProperty('has_alternate_items') &&
      item?.has_alternate_items == 'Y'
    ) {
      fetchAlternateFnbItemData(item);
    } else if (
      item?.hasOwnProperty('is_combo') &&
      item?.is_combo == 'Y' &&
      item?.combo_pack?.length
    ) {
      let tempItem = _.cloneDeep(item);
      // let tempQtyCount =
      //   type == 'sub'
      //     ? parseInt(
      //       (tempItem?.quantity ? tempItem?.quantity : tempItem?.Quantity) || 0,
      //     ) - 1
      //     : parseInt(
      //       (tempItem?.quantity ? tempItem?.quantity : tempItem?.Quantity) || 0,
      //     ) + 1;

      let tempQtyCount =
        type == 'sub'
          ? parseInt(getCount(selectedFnbItem?.[0], item) || 0) - 1
          : parseInt(getCount(selectedFnbItem?.[0], item) || 0) + 1;

      console.log('tempQtyCount TEST', tempQtyCount);
      console.log('item TEST HELLO', item);
      tempItem?.combo_pack?.map((cat) => {
        cat?.combo_items?.map((it) => {
          it['quantity'] = 0;
        });
      });
      if (type == 'sub' && tempQtyCount <= 0) {
        dispatch(onSelectFnb(type, item));
      } else {
        setTempSelectedFnb(tempItem);
        setTempItemCount(tempQtyCount);
        setComboPopup(true);
      }
    } else {
      dispatch(onSelectFnb(type, item));
    }
  };

  const onChangeComboItems = (food, index, category, categoryindex, type) => {
    let totalItemSelected = tempSelectedFnb?.combo_pack[
      categoryindex
    ]?.combo_items?.reduce((acc, { quantity }) => acc + parseInt(quantity || 0), 0);
    if (type == 'add') {
      if (category['min_max_setting'] == 'Y') {
        if (totalItemSelected >= category.max_quantity * tempItemCount) {
          toast.error('All items Selected for this category');
        } else {
          tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity++;
        }
      } else {
        if (totalItemSelected >= category.quantity * tempItemCount) {
          toast.error('All items Selected for this category');
        } else {
          tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity++;
        }
      }
    } else if (type == 'minus') {
      if (
        tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity > 0
      ) {
        tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity--;
      }
    }
  };

  const _onChangeComboItems = (food, index, category, categoryindex, type) => {
    let totalItemSelected = tempSelectedFnb?.combo_pack[
      categoryindex
    ]?.combo_items?.reduce((acc, { quantity }) => acc + parseInt(quantity || 0), 0);
    if (type == 'add') {
      if (category['min_max_setting'] == 'Y') {
        if (totalItemSelected >= category.max_quantity * tempItemCount) {
          if (
            tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity >=
            category.max_quantity * tempItemCount
          ) {
            toast.error('All items Selected for this category');
          }

          let sortedArray = [
            ...tempSelectedFnb.combo_pack[categoryindex].combo_items,
          ]
            .filter((x) => x.item_id != food.item_id)
            .sort((a, b) => b.quantity - a.quantity);

          for (const _item of sortedArray) {
            let checkIndex = tempSelectedFnb.combo_pack[
              categoryindex
            ].combo_items.findIndex((_c_item) => _c_item.item_id == _item.item_id);
            if (
              checkIndex > -1 &&
              tempSelectedFnb.combo_pack[categoryindex].combo_items[checkIndex]
                .quantity > 0
            ) {
              tempSelectedFnb.combo_pack[categoryindex].combo_items[checkIndex]
                .quantity--;
              tempSelectedFnb.combo_pack[categoryindex].combo_items[index]
                .quantity++;
              break;
            }
          }
        } else {
          tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity++;
        }
      } else {
        if (totalItemSelected >= category.quantity * tempItemCount) {
          if (
            tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity >=
            category.quantity * tempItemCount
          ) {
            toast.error('All items Selected for this category');
          }

          let sortedArray = [
            ...tempSelectedFnb.combo_pack[categoryindex].combo_items,
          ]
            .filter((x) => x.item_id != food.item_id)
            .sort((a, b) => b.quantity - a.quantity);

          for (const _item of sortedArray) {
            let checkIndex = tempSelectedFnb.combo_pack[
              categoryindex
            ].combo_items.findIndex((_c_item) => _c_item.item_id == _item.item_id);
            if (
              checkIndex > -1 &&
              tempSelectedFnb.combo_pack[categoryindex].combo_items[checkIndex]
                .quantity > 0
            ) {
              tempSelectedFnb.combo_pack[categoryindex].combo_items[checkIndex]
                .quantity--;
              tempSelectedFnb.combo_pack[categoryindex].combo_items[index]
                .quantity++;
              break;
            }
          }
        } else {
          tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity++;
        }
      }
    } else if (type == 'minus') {
      if (
        tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity > 0
      ) {
        tempSelectedFnb.combo_pack[categoryindex].combo_items[index].quantity--;
      }
    }
  };

  const onSaveComboChanges = () => {
    let errorCount = 0;
    let errMsg = '';
    let finalComboPack = [];
    tempSelectedFnb.combo_pack.forEach((category, categoryIndex) => {
      let checkQuantity = 0;
      let categoryQty =
        category['min_max_setting'] == 'Y'
          ? category.min_quantity * tempItemCount
          : category.quantity * tempItemCount;
      category.combo_items.forEach((items) => {
        checkQuantity += items.quantity;
        if (items.quantity > 0) {
          finalComboPack.push(items);
        }
      });
      if (checkQuantity < categoryQty) {
        errorCount++;
        errMsg = `Please Select ${parseInt(
          categoryQty - checkQuantity,
        )} more Item for ${category.category_name} category`;
      }
    });

    if (errorCount > 0) {
      toast.error(errMsg);
      return false;
    } else {
      onSaveComboPack({
        finalComboPack: finalComboPack,
        combo_pack: tempSelectedFnb['combo_pack'] || [],
      });
      setComboPopup(false);
    }
  };

  const onSaveComboPack = (payload) => {
    item['final_combo_array'] = _.cloneDeep(payload.finalComboPack);
    item['combo_pack'] = _.cloneDeep(payload.combo_pack);
    dispatch(onSelectFnb(tempComboAction, item));
  };

  const selected_language = useSelector((state) => state.movies.selected_language);

  const { lang_name, iso_2, lang_id } = selected_language;

  const getCount = (selectedItm, itm) => {
    if (!!selectedItm) return selectedItm?.Quantity;
    else return itm?.Quantity;
  };
  const getCountArray = (selectedItmArr, itm) => {
    console.log(selectedItmArr, 'selectedItmArrselectedItmArr');
    let selectedItm = selectedItmArr?.find((x) => x?.item_id == itm?.item_id);
    if (!!selectedItm) return selectedItm?.Quantity;
    else return itm?.Quantity;
  };

  const getComboQtyText = (categoryIndex) => {
    let selectedCategory = {
      min_max_setting: 'N',
      min_quantity: 0,
      max_quantity: 0,
      quantity: 0,
    };
    Object.keys(selectedCategory).map((key) => {
      selectedCategory[key] =
        tempSelectedFnb?.combo_pack[categoryIndex][key] || selectedCategory[key];
    });
    let newQty = selectedCategory['quantity'] * tempItemCount;
    let newMinQty = selectedCategory['min_quantity'] * tempItemCount;
    let newMaxQty = selectedCategory['max_quantity'] * tempItemCount;
    let text = ``;
    if (selectedCategory['min_max_setting'] == 'Y') {
      text = `Min Qty. ${newMinQty} & Max Qty. ${newMaxQty}`;
    } else {
      text = `Select Atleast ${newQty} Quantity`;
    }
    return text;
  };
  return (
    <motion.div
      className=""
      initial={{ x: -75, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.75 }}
    >
      <Modal
        show={showAlternatePopup}
        className="alternate-fnb-popup"
        onHide={() => setAlternatePopup(false)}
        size="lg"
      >
        <Modal.Body>
          <section
            className={isMobile ? 'alternate_wrapper_mobile' : 'alternate_wrapper'}
          >
            {tempSelectedFnb &&
              tempSelectedFnb?.alternate_items?.length &&
              tempSelectedFnb?.alternate_items?.map((elem, index) => (
                <div className="fnb-card mb-2">
                  <figure className="img-wrapper">
                    <img
                      src={
                        elem.original_item_image_url
                          ? elem.original_item_image_url
                          : dummyPosterStatic
                      }
                      alt={''}
                    />
                  </figure>
                  <article style={{ margin: '0', height: isMobile ? 'auto' : '' }}>
                    <div
                      className="fnb-content-row "
                      style={{
                        display: !isMobile ? 'flex' : undefined,
                      }}
                    >
                      <p className="">{elem.item_name}</p>
                    </div>

                    <div
                      style={{ width: '100%' }}
                      className={`w-full ${isMobile ? 'flex-column' : 'flex-row'}`}
                    >
                      {!getCountArray(allSelectedFnbItem, elem) ||
                      getCountArray(allSelectedFnbItem, elem) == 0 ? (
                        <aside
                          className={`aside_content flex justify-content-between align-items-center ${
                            isMobile ? 'flex-column' : 'flex-row'
                          }`}
                        >
                          <p
                            style={{ fontSize: '12px' }}
                            className={`descrip_space d-flex justify-content-start align-items-center ${
                              isMobile
                                ? ' width-100 d-flex justify-content-center align-items-center'
                                : ''
                            }`}
                          >
                            {curr_code} {currencyFormatter(elem.fp_total_amount)}
                          </p>
                          <button
                            className={`btn-main-fnb ${
                              category_id == 1 && ' golden_btn_pvt '
                            }`}
                            onClick={() => onSelectFnbItem('add', elem)}
                          >
                            {t('Add')}
                          </button>
                        </aside>
                      ) : (
                        <aside
                          style={{
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                          className={`modifier-btn d-flex justify-content-between align-items-center ${
                            isMobile ? 'flex-column' : 'flex-row'
                          }`}
                        >
                          <p
                            style={{ fontSize: '12px' }}
                            className={`descrip_space d-flex justify-content-center ${
                              isMobile ? 'width-100' : 'widht-auto'
                            }`}
                          >
                            {curr_code} {currencyFormatter(elem.fp_total_amount)}
                          </p>
                          <div
                            className="mod_btn"
                            style={{
                              justifyContent: isMobile ? 'center' : undefined,
                            }}
                          >
                            <span
                              className={
                                !getCountArray(allSelectedFnbItem, elem)
                                  ? 'inactive'
                                  : ''
                              }
                              onClick={() => {
                                if (
                                  !!fnb_item_id &&
                                  elem.item_id == fnb_item_id &&
                                  getCountArray(allSelectedFnbItem, elem) <=
                                    scheduleDetails?.selectedSeats?.length
                                ) {
                                  return;
                                }

                                onSelectFnbItem('sub', elem);
                              }}
                            >
                              <FnbRemove style={{ transform: 'scale(1.4)' }} />
                            </span>
                            <span
                              className={`mx-2 ${
                                !getCountArray(allSelectedFnbItem, elem)
                                  ? 'inactive'
                                  : ''
                              }`}
                            >
                              {getCountArray(allSelectedFnbItem, elem) !== 0 &&
                              getCountArray(allSelectedFnbItem, elem)
                                ? getCountArray(allSelectedFnbItem, elem)
                                : '0'}
                            </span>
                            <span
                              className="fnb_add_btn"
                              onClick={() => onSelectFnbItem('add', elem)}
                            >
                              {category_id == 1 ? (
                                <FnbAddGold style={{ transform: 'scale(1.4)' }} />
                              ) : (
                                <FnbAdd style={{ transform: 'scale(1.4)' }} />
                              )}
                            </span>
                          </div>
                        </aside>
                      )}
                    </div>
                  </article>
                </div>
              ))}
          </section>
        </Modal.Body>
      </Modal>

      <Modal
        show={showComboPopup}
        className="alternate-fnb-popup"
        onHide={() => setComboPopup(false)}
        size="lg"
      >
        <Modal.Body>
          {tempSelectedFnb && tempSelectedFnb?.combo_pack?.length ? (
            <div className="combo_container">
              <div className="combo_title_bar">{tempSelectedFnb?.item_name}</div>
              <div className="combo_content">
                {tempSelectedFnb?.combo_pack?.map((category, catIndex) => {
                  return (
                    <div className="combo_content_wrapper" key={catIndex}>
                      <div className="d-flex align-items-center">
                        <div className="combo_category_name">
                          {category?.category_name}
                        </div>
                        <span class="combo-category-qty-count">
                          ({getComboQtyText(catIndex)})
                        </span>
                      </div>
                      {category?.combo_items?.map((_cItem, cItemIndex) => {
                        return (
                          <div
                            class="combo_item_list"
                            key={String(cItemIndex) + '_' + String(catIndex)}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="combo_item_name">
                                {_cItem?.item_name}
                              </div>
                              <div className="combo_item_selection">
                                <aside
                                  style={{
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                  className={`modifier-btn d-flex justify-content-between align-items-center ${
                                    isMobile ? 'flex-column' : 'flex-row'
                                  }`}
                                >
                                  <div
                                    className="mod_btn"
                                    style={{
                                      justifyContent: isMobile
                                        ? 'center'
                                        : undefined,
                                    }}
                                  >
                                    <span
                                      className={
                                        !_cItem?.quantity ? 'inactive' : ''
                                      }
                                      onClick={() => {
                                        if (
                                          !!fnb_item_id &&
                                          _cItem.item_id == fnb_item_id &&
                                          _cItem?.quantity <=
                                            scheduleDetails?.selectedSeats?.length
                                        ) {
                                          return;
                                        }
                                        onChangeComboItems(
                                          _cItem,
                                          cItemIndex,
                                          category,
                                          catIndex,
                                          'minus',
                                        );
                                      }}
                                    >
                                      <FnbRemove
                                        style={{ transform: 'scale(1.4)' }}
                                      />
                                    </span>
                                    <span
                                      className={`mx-3 ${
                                        !_cItem?.quantity ? 'inactive' : ''
                                      }`}
                                    >
                                      {_cItem?.quantity !== 0 && _cItem?.quantity
                                        ? _cItem?.quantity
                                        : '0'}
                                    </span>
                                    <span
                                      className="fnb_add_btn"
                                      onClick={() =>
                                        onChangeComboItems(
                                          _cItem,
                                          cItemIndex,
                                          category,
                                          catIndex,
                                          'add',
                                        )
                                      }
                                    >
                                      <FnbAdd style={{ transform: 'scale(1.4)' }} />
                                    </span>
                                  </div>
                                </aside>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="combo_container">
              <div className="text-center">No Items Found!</div>
            </div>
          )}
          <div className="combo_footer">
            <div className="btn-section d-flex justify-content-between align-items-center">
              <div className="btn-popup-sm" onClick={() => setComboPopup(false)}>
                Cancel
              </div>
              <div className="btn-popup-sm" onClick={() => onSaveComboChanges()}>
                Add To Cart
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCustomizationPopup && !showComboPopup && !showAlternatePopup}
        className="alternate-fnb-popup"
        onHide={() => setCustomizationPopup(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {' '}
            <div className="combo_title_custom">Would You Like to Add Extra ?</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {tempSelectedFnb && tempSelectedFnb?.customizationItemsList?.length ? (
            <div className="combo_container">
              <div className="combo_content">
                <div className="combo_content_wrapper">
                  {tempSelectedFnb?.customizationItemsList?.map(
                    (elem, itemsIndex) => {
                      return (
                        <div class="combo_item_list" key={itemsIndex}>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="combo_item_name">{elem?.item_name}</div>
                            <div className="combo_item_selection">
                              <>
                                {!getCountArray(allSelectedFnbItem, elem) ||
                                getCountArray(allSelectedFnbItem, elem) == 0 ? (
                                  <aside
                                    className={`aside_content flex justify-content-between align-items-center ${
                                      isMobile ? 'flex-column' : 'flex-row'
                                    }`}
                                  >
                                    <p
                                      style={{ fontSize: '12px' }}
                                      className={`descrip_space d-flex justify-content-center align-items-center mr-3 ${
                                        isMobile
                                          ? ' width-100 d-flex justify-content-center align-items-center'
                                          : ''
                                      }`}
                                    >
                                      {curr_code}{' '}
                                      {currencyFormatter(elem.fp_total_amount)}
                                    </p>
                                    <button
                                      className={`btn-main-fnb ${
                                        category_id == 1 && ' golden_btn_pvt '
                                      }`}
                                      onClick={() => onSelectFnbItem('add', elem)}
                                    >
                                      {t('Add')}
                                    </button>
                                  </aside>
                                ) : (
                                  <aside
                                    style={{
                                      width: '100%',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                    }}
                                    className={`modifier-btn d-flex justify-content-between align-items-center ${
                                      isMobile ? 'flex-column' : 'flex-row'
                                    }`}
                                  >
                                    <p
                                      style={{ fontSize: '12px' }}
                                      className={`descrip_space d-flex justify-content-center mr-4 ${
                                        isMobile ? 'width-100' : 'widht-auto'
                                      }`}
                                    >
                                      {curr_code}{' '}
                                      {currencyFormatter(elem.fp_total_amount)}
                                    </p>
                                    <div
                                      className="mod_btn"
                                      style={{
                                        justifyContent: isMobile
                                          ? 'center'
                                          : undefined,
                                      }}
                                    >
                                      <span
                                        className={
                                          !getCountArray(allSelectedFnbItem, elem)
                                            ? 'inactive'
                                            : ''
                                        }
                                        onClick={() => {
                                          if (
                                            !!fnb_item_id &&
                                            elem?.item_id == fnb_item_id &&
                                            getCountArray(
                                              allSelectedFnbItem,
                                              elem,
                                            ) <=
                                              scheduleDetails?.selectedSeats?.length
                                          ) {
                                            return;
                                          }

                                          onSelectFnbItem('sub', elem);
                                        }}
                                      >
                                        <FnbRemove
                                          style={{ transform: 'scale(1.4)' }}
                                        />
                                      </span>
                                      <span
                                        className={`mx-2 ${
                                          !getCountArray(allSelectedFnbItem, elem)
                                            ? 'inactive'
                                            : ''
                                        }`}
                                      >
                                        {getCountArray(allSelectedFnbItem, elem) !==
                                          0 &&
                                        getCountArray(allSelectedFnbItem, elem)
                                          ? getCountArray(allSelectedFnbItem, elem)
                                          : '0'}
                                      </span>
                                      <span
                                        className="fnb_add_btn"
                                        onClick={() => onSelectFnbItem('add', elem)}
                                      >
                                        {category_id == 1 ? (
                                          <FnbAddGold
                                            style={{ transform: 'scale(1.4)' }}
                                          />
                                        ) : (
                                          <FnbAdd
                                            style={{ transform: 'scale(1.4)' }}
                                          />
                                        )}
                                      </span>
                                    </div>
                                  </aside>
                                )}
                              </>
                            </div>
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="combo_container">
              <div className="text-center">No Items Found!</div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <div className="fnb-card">
        <figure className="img-wrapper">
          <img src={item.item_image_url} alt={item.item_name} />
        </figure>
        <article
          className={
            isMobile
              ? 'd-flex flex-column align-items-center justify-content-between'
              : 'fnb_item_wrapper'
          }
        >
          <div
            className="fnb-content-row"
            style={{
              display: !isMobile ? 'flex' : undefined,
              height: !isMobile ? '50%' : undefined,
            }}
          >
            {/* <span>{item.fi_order}</span> */}
            <p className="">
              {getLangSpecificAttribute(
                item?.FnbContent,
                lang_id,
                'item_lang_name',
              ) || item.item_name}
            </p>
            <p className="">
              {curr_code} {currencyFormatter(item.fp_total_amount)}
            </p>
          </div>

          {/* Combo Custimizable Code start Here */}
          <div
            style={{ width: '100%' }}
            className={`w-full ${isMobile ? 'flex-column' : 'flex-row'}`}
          >
            {item?.hasOwnProperty('has_alternate_items') &&
            item?.has_alternate_items == 'Y' ? (
              <>
                <aside
                  className={`aside_content flex justify-content-between align-items-center ${
                    isMobile ? 'flex-column' : 'flex-row'
                  }`}
                >
                  <p
                    style={{ fontSize: '12px' }}
                    className={`descrip_space d-flex justify-content-center align-items-center ${
                      isMobile
                        ? ' width-100 d-flex justify-content-center align-items-center'
                        : ''
                    }`}
                  >
                    <span>Starts </span> {curr_code}{' '}
                    {currencyFormatter(item.fp_total_amount)}
                  </p>
                  <button
                    className={`${category_id == 1 && ' golden_btn_pvt '} ${
                      item?.alternate_items?.reduce(
                        (acc, _item) =>
                          acc +
                          parseInt(getCountArray(allSelectedFnbItem, _item) || 0),
                        0,
                      )
                        ? 'alternate_select_btn'
                        : 'btn-main-fnb'
                    }`}
                    onClick={() => onSelectFnbItem('add', item)}
                  >
                    {item?.alternate_items &&
                    item?.alternate_items.length &&
                    item?.alternate_items?.reduce(
                      (acc, _item) =>
                        acc +
                        parseInt(getCountArray(allSelectedFnbItem, _item) || 0),
                      0,
                    )
                      ? 'Selected (' +
                        item?.alternate_items?.reduce(
                          (acc, _item) =>
                            acc +
                            parseInt(getCountArray(allSelectedFnbItem, _item) || 0),
                          0,
                        ) +
                        ')'
                      : t('Select')}
                  </button>
                </aside>
              </>
            ) : (
              <>
                {!getCount(selectedFnbItem?.[0], item) ||
                getCount(selectedFnbItem?.[0], item) == 0 ? (
                  <aside
                    className={`aside_content flex justify-content-between align-items-center ${
                      isMobile ? 'flex-column' : 'flex-row'
                    }`}
                  >
                    {/* {!isMobile ? (
                  <p className="descrip_space">
                    {curr_code} {currencyFormatter(item.fp_total_amount)}
                  </p>
                ) : (
                  <></>
                )} */}
                    <p
                      style={{ fontSize: '12px' }}
                      className={`descrip_space d-flex justify-content-center align-items-center ${
                        isMobile
                          ? ' width-100 d-flex justify-content-center align-items-center'
                          : ''
                      }`}
                    >
                      {curr_code} {currencyFormatter(item.fp_total_amount)}
                    </p>
                    <button
                      className={`btn-main-fnb ${
                        category_id == 1 && ' golden_btn_pvt '
                      }`}
                      /*style={{ marginRight: "5px" }}*/
                      onClick={() => onSelectFnbItem('add', item)}
                    >
                      {t('Add')}
                    </button>
                  </aside>
                ) : (
                  <aside
                    style={{
                      width: '100%',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                    className={`modifier-btn d-flex justify-content-between align-items-center ${
                      isMobile ? 'flex-column' : 'flex-row'
                    }`}
                  >
                    <p
                      style={{ fontSize: '12px' }}
                      className={`descrip_space d-flex justify-content-center ${
                        isMobile ? 'width-100' : 'widht-auto'
                      }`}
                    >
                      {curr_code} {currencyFormatter(item.fp_total_amount)}
                    </p>
                    <div
                      className="mod_btn"
                      style={{
                        justifyContent: isMobile ? 'center' : undefined,
                      }}
                    >
                      <span
                        className={
                          !getCount(selectedFnbItem?.[0], item) ? 'inactive' : ''
                        }
                        onClick={() => {
                          if (
                            !!fnb_item_id &&
                            item.item_id == fnb_item_id &&
                            getCount(selectedFnbItem?.[0], item) <=
                              scheduleDetails?.selectedSeats?.length
                          ) {
                            return;
                          }

                          onSelectFnbItem('sub', item);
                        }}
                      >
                        <FnbRemove style={{ transform: 'scale(1.4)' }} />
                      </span>
                      <span
                        className={`mx-2 ${
                          !getCount(selectedFnbItem?.[0], item) ? 'inactive' : ''
                        }`}
                      >
                        {getCount(selectedFnbItem?.[0], item) !== 0 &&
                        getCount(selectedFnbItem?.[0], item)
                          ? getCount(selectedFnbItem?.[0], item)
                          : '0'}
                      </span>
                      <span
                        className="fnb_add_btn"
                        onClick={() => onSelectFnbItem('add', item)}
                      >
                        {category_id == 1 ? (
                          <FnbAddGold style={{ transform: 'scale(1.4)' }} />
                        ) : (
                          <FnbAdd style={{ transform: 'scale(1.4)' }} />
                        )}
                      </span>
                    </div>
                  </aside>
                )}
              </>
            )}
          </div>
          {(item?.hasOwnProperty('has_alternate_items') &&
          item?.has_alternate_items == 'Y'
            ? item?.alternate_items?.reduce(
                (acc, _item) =>
                  acc + parseInt(getCountArray(allSelectedFnbItem, _item) || 0),
                0,
              )
            : getCount(selectedFnbItem?.[0], item)) &&
          item?.is_customization_available == 'Y' ? (
            <div
              className="customization_btn"
              onClick={() => {
                setClickAddExtra(true);
                onFetchCustomizations(item);
              }}
            >
              Add Customization
            </div>
          ) : (
            ''
          )}

          {/* Combo Custimizable Code End Here */}
        </article>
        {/* <aside className="">
          <p>25% off</p>
          <p>CHF 48</p>
        </aside> */}
      </div>
    </motion.div>
  );
}

export default withNamespaces()(Fnb);
